// src/lib/agent-journee-api.js — client des deux portes de « Mon planning »
// (lib/ecrans/agent.js, routées par /api/beds24-mapping en POST { action }).
//
// Le périmètre est résolu CÔTÉ SERVEUR : ce client n'envoie ni logement ni
// adresse. Une lecture ratée LÈVE : l'écran dit « — », jamais « 0 ménage ».
//
// Les écrans de ménage et la checklist parlent en colonnes de `menage_runs`
// (`status`, `heure_fixee`…) : `versRun` traduit la réponse de la porte, une
// seule fois, ici.

import { supabase } from '../supabase'

const ENDPOINT = '/api/beds24-mapping'

async function lire(body) {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(json.error || `Erreur ${res.status}`)
    err.status = res.status
    throw err
  }
  return json
}

export function versRun(m, date) {
  return {
    id: m.id,
    logement_id: m.logement?.id || null,
    logement_nom: m.logement?.nom || null,
    scheduled_date: date,
    status: m.statut,
    heure_fixee: m.heure,
    duree_min: m.duree_min,
    guest_count: m.personnes,
    completed_at: m.termine_a,
    depart_reporte_au: m.depart_reporte_au,
    items_checked: m.items_checked || {},
    photos: Array.isArray(m.photos) ? m.photos : [],
  }
}

/** SA journée : { aujourdhui, prenom, runs, changements, logements }. */
export async function fetchJourneeAgent() {
  const r = await lire({ action: 'ecran_agent_planning_lire' })
  const jour = (Array.isArray(r.jours) ? r.jours : [])[0] || { date: r.aujourdhui, menages: [] }
  return {
    aujourdhui: r.aujourdhui,
    prenom: r.prenom || null,
    runs: (jour.menages || []).map((m) => versRun(m, jour.date)),
    changements: Array.isArray(r.changements) ? r.changements : [],
    logements: Array.isArray(r.logements) ? r.logements : [],
  }
}

/** SES ménages du mois : { faits, faitsParLogement, runs }. */
export async function fetchMoisAgent(mois) {
  const r = await lire({ action: 'ecran_agent_mois_lire', mois })
  return {
    faits: r.faits,
    faitsParLogement: r.faits_par_logement || {},
    runs: (Array.isArray(r.menages) ? r.menages : []).map((m) => versRun(m, m.date)),
  }
}
